import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RecuperacaoSenha from "./recuperacaoSenha";
import { removeDots } from "../../../../helpers/removeDots";
import CodigoResetSenha from "./codigoResetSenha";
import {
  EnviarCodigoValidacaoSenha,
  ValidarCodigoResetSenhaAction,
} from "../../../../store/actions/usuario";
import CriarNovaSenha from "./criarNovaSenha";

const PassosResetSenha = ({ setCloseModal, cpf }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");

  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrevius = () => {
    setCurrentStep(currentStep - 1);
  };

  async function sendCodeRecovery() {
    setLoading(true);
    try {
      await EnviarCodigoValidacaoSenha({ cpf: removeDots(cpf) });
      setLoading(false);
      handleNext();
    } catch (error) {
      setLoading(false);
    }
  }

  async function ValidarCodigo() {
    setLoading(true);
    try {
      await ValidarCodigoResetSenhaAction({
        cpf: removeDots(cpf),
        token: token,
      });
      setLoading(false);
      handleNext();
    } catch (e) {
      setLoading(false);
      setShowErrorAlert(true);
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 3000);
    }
  }

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <RecuperacaoSenha
            closeModal={setCloseModal}
            loading={loading}
            cpf={cpf}
            sendCode={sendCodeRecovery}
          />
        );
      case 1:
        return (
          <CodigoResetSenha
            closeModal={setCloseModal}
            cpf={cpf}
            sendCode={ValidarCodigo}
            token={token}
            setToken={setToken}
          />
        );
      case 2:
        return (
          <CriarNovaSenha
            closeModal={setCloseModal}
            cpf={cpf}
            sendCode={ValidarCodigo}
            token={token}
            setToken={setToken}
            setLoading={setLoading}
          />
        );
      default:
        return null;
    }
  };

  return renderStepContent();
};

export default PassosResetSenha;
